import UserJobProfileForm from "./user-job-profile-form";

export default UserJobProfileForm;